import { useEffect, useState } from "react";

import { AreaMetaFile } from "@mapmycustomers/shared/types/territory/AreaRegion";
import AreaType from "@mapmycustomers/shared/types/territory/AreaType";

import getBoundaryUrl from "@app/scene/map/utils/getBoundaryUrl";

const INITIAL_STATE = {
  files: [],
  regions: [],
};

const useAreaTypeMetaData = (
  areaType: AreaType,
  active: boolean = true
): [metaData: AreaMetaFile, loading: boolean, error: undefined | unknown] => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(undefined);
  const [metaData, setMetaData] = useState<AreaMetaFile>(INITIAL_STATE);

  useEffect(() => {
    if (!active) {
      return;
    }

    setLoading(true);
    fetch(getBoundaryUrl("meta", areaType))
      .then((response) => response.json())
      .then((json: AreaMetaFile) => {
        setMetaData(json);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
    return () => {
      setMetaData(INITIAL_STATE);
    };
  }, [active, areaType]);

  return [metaData, loading, error];
};

export default useAreaTypeMetaData;
